import React from 'react';

class Footer extends React.Component<any, any> {
	
	constructor(props:any) {
        super(props);
	}
	componentDidMount() {
      }
	componentWillMount(){
	}
    render(){
        return (
            <div  >
              
            </div>
            
        );
    }
}
export default Footer;
